import React, { useState, useEffect } from "react";
import { DataGrid } from "@material-ui/data-grid";
import LoadingSimpleBackdrop from "../tools/LoadingSimpleBackdrop";
import InventoryService from "../../services/InventoryService";
import Title from "../../components/Title";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import ArticleIcon from "@mui/icons-material/Article";
import { id } from "date-fns/locale";
import { useNavigate } from "react-router-dom";
import { exportToExcel } from "../../helpers/ExportHelpers";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    elevation: 0,
  },
  style1: {
    backfaceVisibility: "cyan",
  },
}));

export default function InventoryOthersTable({
  filterCount,
  excelExport,
  nameMateriel,
  codeImmo,
  stateFilter,
  directionFilter, // ✅ prop contenant la direction sélectionnée (state React)
}) {
  const [rows, setRows] = useState([]);
  const [immoArray, setImmoArray] = useState([]);
  const classes = useStyles();
  const navigate = useNavigate();

  const [openLoadingSimpleBackdrop, setOpenLoadingSimpleBackdrop] = React.useState(false);

  function loadTable(name_materiel, code_immo, state, direction, mes_materiels) {
    setOpenLoadingSimpleBackdrop(true);
    setRows([]);
    console.log("📤 loadTable → direction =", direction);

    InventoryService.getMaterielStatus(
      name_materiel,
      code_immo,
      state,
      direction,
      mes_materiels
    ).then((result) => {
      if (result && result.status) {
        setRows(
          result.data.map((row) => ({
            ...row,
            id: row.history_id,
            id2: row.code_immo_id,
            code: row.code_immo,
          }))
        );
        setOpenLoadingSimpleBackdrop(false);
      } else {
        setOpenLoadingSimpleBackdrop(false);
      }
    });
  }

  function initalizeStorage(name) {
    if (localStorage.getItem(name)) {
      localStorage.setItem(name, localStorage.getItem(name));
    } else {
      localStorage.setItem(name, "");
    }
  }

  const handleChecked = (id) => (ev) => {
    if (ev.target.checked == true) {
      immoArray.push(id);
    } else {
      immoArray.pop(id);
    }
    setImmoArray((immoArray) => [...immoArray]);
    localStorage.setItem("immoArrayStorage", immoArray);
  };

  const handleExportToExcel = (declenceur) => {
    if (declenceur > 0)
      exportToExcel(rows, columns, "Matériels " + new Date().toLocaleString());
  };

  useEffect(() => {
    handleExportToExcel(excelExport);
  }, [excelExport]);

  // ✅ Rechargement quand filterCount OU directionFilter change
  useEffect(() => {
    localStorage.removeItem("immoArrayStorage", immoArray);
    initalizeStorage("name_materiel");
    initalizeStorage("code_immo");
    initalizeStorage("state");

    const name_materiel = localStorage.getItem("name_materiel");
    const code_immo = localStorage.getItem("code_immo");
    const state = localStorage.getItem("state");

    // 🔑 direction vient UNIQUEMENT de la prop
    const direction = directionFilter || "";

    const mes_materiels = localStorage.getItem("mes_materiels");

    console.log("🔄 useEffect loadTable → direction =", direction);

    loadTable(name_materiel, code_immo, state, direction, mes_materiels);
  }, [filterCount, directionFilter]);

  const handleSelect = (id2, code) => (ev) => {
    navigate("/Logistic/recap/" + id2);
    localStorage.setItem("my_id", id2);
    localStorage.setItem("codeI", code);
  };

  const columns = [
    {
      field: "code_immo",
      headerName: "Code Immo",
      width: 250,
    },
    {
      field: "name",
      headerName: "Matériel",
      width: 250,
    },
    {
      field: "direction",
      headerName: "Direction",
      width: 150,
    },
    {
      field: "inventory_status",
      headerName: "Statut du materiel",
      width: 250,
      renderCell: (params) => {
        if (params.row.inventory_status == "AFFECTE") {
          return (
            <div
              style={{
                background: "#ef6c00",
                width: 250,
                textAlign: "center",
                color: "rgb(248, 248, 248)",
                fontWeight: "bold",
                fontFamily: "Arial, Helvetica, sans-serif",
              }}
            >
              {params.row.inventory_status}
            </div>
          );
        } else if (params.row.inventory_status == "EN STOCK") {
          return (
            <div
              style={{
                background: "#1565c0",
                width: 250,
                textAlign: "center",
                color: "rgb(248, 248, 248)",
                fontWeight: "bold",
                fontFamily: "Arial, Helvetica, sans-serif",
              }}
            >
              EN STOCK
            </div>
          );
        } else if (params.row.inventory_status == "NON AFFECTE") {
          return (
            <div
              style={{
                background: "#2e7d32",
                width: 250,
                textAlign: "center",
                color: "rgb(248, 248, 248)",
                fontWeight: "bold",
                fontFamily: "Arial, Helvetica, sans-serif",
              }}
            >
              {params.row.inventory_status}
            </div>
          );
        }
      },
    },
    {
      field: "date_inventaire",
      headerName: "Date d'affectation",
      width: 250,
    },
    {
      field: "observation",
      headerName: "Observation",
      width: 250,
    },
    {
      field: "period",
      headerName: "Période",
      width: 250,
    },
    {
      field: "logistics_manager",
      headerName: "Resp affectation",
      width: 250,
    },
    {
      field: "new_affectation",
      headerName: "Nouveau détenteur",
      width: 250,
    },
    {
      field: "oldest_affectation",
      headerName: "Ancien détenteur",
      width: 250,
    },
    {
      field: "status_by_the_logistics_manager",
      headerName: "Validation Responsable Logistique",
      width: 250,
      renderCell: (params) => {
        if (params.row.status_by_the_logistics_manager == "PENDING") {
          return (
            <div
              style={{
                background: "rgb(167, 54, 54)",
                width: 250,
                textAlign: "center",
                color: "rgb(248, 248, 248)",
                fontWeight: "bold",
                fontFamily: "Arial, Helvetica, sans-serif",
              }}
            >
              En attente de validation
            </div>
          );
        }
        if (params.row.status_by_the_logistics_manager == "CONFIRMED") {
          return (
            <div
              style={{
                backgroundColor: "rgb(58, 139, 58)",
                width: 250,
                textAlign: "center",
                color: "rgb(248, 248, 248)",
                fontWeight: "bold",
                fontFamily: "Arial, Helvetica, sans-serif",
              }}
            >
              Validé
            </div>
          );
        }
        if (params.row.status_by_the_logistics_manager == "DECLINED") {
          return (
            <div
              style={{
                background: "rgb(167, 54, 54)",
                width: 250,
                textAlign: "center",
                color: "rgb(248, 248, 248)",
                fontWeight: "bold",
                fontFamily: "Arial, Helvetica, sans-serif",
              }}
            >
              Non validé
            </div>
          );
        }
      },
    },
    {
      field: "status_by_the_holder",
      headerName: "Validation détenteur",
      width: 250,
      renderCell: (params) => {
        if (params.row.status_by_the_holder == "PENDING") {
          return (
            <div
              style={{
                background: "rgb(167, 54, 54)",
                width: 250,
                textAlign: "center",
                color: "rgb(248, 248, 248)",
                fontWeight: "bold",
                fontFamily: "Arial, Helvetica, sans-serif",
              }}
            >
              En attente de validation
            </div>
          );
        }
        if (params.row.status_by_the_holder == "CONFIRMED") {
          return (
            <div
              style={{
                backgroundColor: "rgb(58, 139, 58)",
                width: 250,
                textAlign: "center",
                color: "rgb(248, 248, 248)",
                fontWeight: "bold",
                fontFamily: "Arial, Helvetica, sans-serif",
              }}
            >
              Validé
            </div>
          );
        }
        if (params.row.status_by_the_holder == "DECLINED") {
          return (
            <div
              style={{
                background: "rgb(167, 54, 54)",
                width: 250,
                textAlign: "center",
                color: "rgb(248, 248, 248)",
                fontWeight: "bold",
                fontFamily: "Arial, Helvetica, sans-serif",
              }}
            >
              Non validé
            </div>
          );
        }
      },
    },
    {
      field: "status_by_the_old_holder",
      headerName: "Validation ancien détenteur",
      width: 250,
      renderCell: (params) => {
        if (params.row.status_by_the_old_holder == "PENDING") {
          return (
            <div
              style={{
                background: "rgb(167, 54, 54)",
                width: 250,
                textAlign: "center",
                color: "rgb(248, 248, 248)",
                fontWeight: "bold",
                fontFamily: "Arial, Helvetica, sans-serif",
              }}
            >
              En attente de validation
            </div>
          );
        }
        if (params.row.status_by_the_old_holder == "CONFIRMED") {
          return (
            <div
              style={{
                backgroundColor: "rgb(58, 139, 58)",
                width: 250,
                textAlign: "center",
                color: "rgb(248, 248, 248)",
                fontWeight: "bold",
                fontFamily: "Arial, Helvetica, sans-serif",
              }}
            >
              Validé
            </div>
          );
        }
        if (params.row.status_by_the_old_holder == "DECLINED") {
          return (
            <div
              style={{
                background: "rgb(167, 54, 54)",
                width: 250,
                textAlign: "center",
                color: "rgb(248, 248, 248)",
                fontWeight: "bold",
                fontFamily: "Arial, Helvetica, sans-serif",
              }}
            >
              Non validé
            </div>
          );
        }
      },
    },
    {
      field: "action",
      headerName: "Action",
      disableClickEventBulging: true,
      renderCell: (params) => {
        return (
          <div>
            <Button>
              <input
                type="checkbox"
                onChange={handleChecked(params.row.code_immo)}
                title={params.row.code_immo}
                checked={immoArray.includes(params.row.code_immo)}
              />
            </Button>
          </div>
        );
      },
      width: 200,
    },
  ];

  return (
    <>
      <LoadingSimpleBackdrop
        openLoadingSimpleBackdrop={openLoadingSimpleBackdrop}
      />
      <Title>
        Liste des matériels par statut: Affectés - En stock - Non affectés
      </Title>
      <div style={{ height: "70vh", width: "100%" }}>
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={10}
          rowsPerPageOptions={[10]}
          getRowId={(row) => row.code_immo_id}
        />
      </div>
    </>
  );
}